import React from "react";
import Banner from "../../../../components/Banner";
import "../../../../assets/styles/career.scss";
import SubjectCards from "./SubjectCards";
import BottomBar from "../../../../components/BottomBar";
import { Bell } from "react-feather";

import { Col, Container, Button, Row } from "reactstrap";

const Cosmetics = () => {
  const handleClick = () => {
    console.log("test");
  };
  return (
    <React.Fragment>
      <Banner
        title="화장품/향수는 어떻게 만들어질까?"
        bg="cosmetics_banner.jpg"
      />
      <Container className="subject_container">
        <Row mb={3}>
          <Col md={6} sm={12}>
            <h2>화학공학이란?</h2>
            <p>
              화학 물질의 생산 및 가공과 관련이 있습니다. 화학 공학은 화학
              물질로부터 금속, 세제, 플라스틱 및 의약품과 같은 제품 개발에
              유용합니다. 일반적으로 화학 엔지니어는 가장 비용 효율적인 방식으로
              화학 물질을 안전하게 사용하기 위해 노력합니다.
            </p>
          </Col>
          <Col md={6} sm={12}>
            <img
              src={require("../../../../assets/img/chem_eng_explain.jpg")}
              className="horizontal"
              alt="ucas_official"
            />
          </Col>
        </Row>
        <Row mb={3}></Row>
        <hr className="mt-4 mb-4" />

        <div className="compulsory-subjects">
          <Row className="mb-3">
            <Col md={8}>
              <h3 className="heading section-title">수강해야 하는 과목 </h3>
            </Col>
          </Row>
          <Row>
            <Col md={3} className="mb-4">
              <SubjectCards title="Maths" img="maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards title="Further Maths" img="further_maths.png" />
            </Col>
            <Col md={3}>
              <SubjectCards title="Physics" img="physics.png" />
            </Col>
            <Col md={3} className="mb-4">
              <SubjectCards title="Chemistry" img="chemistry.png" />
            </Col>
          </Row>
        </div>
      </Container>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Button
              color="danger"
              style={{ width: "100%" }}
              onClick={handleClick}
            >
              수강 신청하기
            </Button>
          </Col>
        </Row>
      </BottomBar>
    </React.Fragment>
  );
};

export default Cosmetics;
